// system/infra-params — the install's real bicep suffix + params, stamped by
// deploy and by a full converge so the updater job can run infra converge
// without guessing the suffix (a wrong suffix provisions a duplicate stack).
//
// Secret audit: every field below is a non-secret resource ID / ref / suffix
// (ARM resource IDs, an image ref, a tenant/client ID, a project endpoint,
// and the deployment suffix) — the plain Metadata row is fine as-is, no KV
// reference needed. If a FUTURE param ever carries a secret (e.g. a
// connection string), store a KV reference string (e.g. `kv://vault/secret`
// or an `op://...` style pointer) here, NEVER the raw secret value.
export interface InfraParams {
  schemaVersion: 1;
  suffix: string;
  bicep: {
    location: string;
    imageRef: string;
    tenantId: string;
    clientId: string;
    foundryResourceId: string;
    foundryProjectEndpoint: string;
    acrPullIdentityResourceId: string;
    acrResourceId: string;
    foundryTracingMode?: string;
  };
  updatedAt: string;
}

export const INFRA_PARAMS_PK = "system";
export const INFRA_PARAMS_RK = "infra-params";

export function infraParamsToEntity(p: InfraParams): { partitionKey: string; rowKey: string; value: string } {
  return { partitionKey: INFRA_PARAMS_PK, rowKey: INFRA_PARAMS_RK, value: JSON.stringify(p) };
}

export function entityToInfraParams(e: { value: string }): InfraParams {
  return JSON.parse(e.value) as InfraParams;
}
